
import React, { Component } from "react";
import { Button, Col, Form, Input, Row, Select, Spin } from "antd";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";

import StudentRouteStore from "../store/StudentRouteStore";
import CompanyStore from "../store/CompanyStore";
const { Option } = Select;

class StudentRouteAdd extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = { loadingSpin: false, RouteId: -1, arealist: [], companyId: "" };


        this.studentRouteStore = new StudentRouteStore(this);
        this.companyStore = new CompanyStore(this);

    }
    async componentDidMount() {
        if (Number(this.props.getUserData().isadmin) !== -1 || Number(this.props.getUserData().isadmin) !== 3) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
        }
        this.AreaLoad();
        const routeId = this.props.routeId;
        console.log("routeId", routeId)
        if (routeId) {
            await this.filldata(routeId);
        }

        this.setState({ update: 1 });
    }

    async filldata(routeId) {
        // debugger
        const getRouteData = await this.studentRouteStore.getRouteData(routeId);
        console.log(getRouteData)
        const singleData = await this.companyStore.getCompanyDataById(
            getRouteData.companyId
        );
        this.setState({ routeId: getRouteData.routeId, companyId: getRouteData.companyId });
        // debugger
        this.formRef.current.setFieldsValue({
            routeId: getRouteData.routeId,
            routeName: getRouteData.routeName,
            routeArea: getRouteData.routeArea.split(",").map(Number),
            companyId: singleData
        });
    }

    OnRouteSubmit = async (fieldsValue) => {
        console.log(this.state.companyId)
        const data = {
            companyId: this.state.companyId,
            routeId: this.state.routeId,
            routeArea: fieldsValue.routeArea,
            routeName: fieldsValue.routeName,
        };

        this.setState({ loading: true });
        const response = await this.studentRouteStore.addData(data);
        await this.props.response(response);

        this.setState({ loading: false });
    };

    closeModal = () => {
        this.props.closeModal();
    };
    AreaLoad = async () => {
        const arealist = await this.studentRouteStore.getArea();
        // console.log(arealist, "arealist");
        await this.setState({ arealist: arealist, update: 1 });
    }
    handleChange = async (comp) => {
        console.log(comp.value);
        await this.setState({ companyId: comp.value });
        await this.formRef.current.setFieldsValue({
            companyId: this.state.companyId,
        });
    }
    render() {
        return (
            <div style={{ padding: 0, height: "100%" }}>
                <div style={{ paddingBottom: "10px", height: "100%" }}>
                    <Spin
                        spinning={this.state.loadingSpin}
                        wrapperClassName="spinClass"
                        fullscreen
                    >
                        <Form
                            ref={this.formRef}
                            layout="vertical"
                            name="nest-messages"
                            onFinish={this.OnRouteSubmit}
                            className="formClass"
                        >
                            <Row className="overflowFormInputs">
                                <Col span={24} className="formColumnClass">
                                    {(this.props.getUserData().isadmin === -1 ||
                                        this.props.getUserData().isadmin === 3) && (
                                            <Form.Item
                                                name="companyId"
                                                // label="Account"
                                                className="uploadCompany"
                                                required={false}
                                                label={
                                                    <span>
                                                        {this.context.translate(
                                                            "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                                                        )}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_ACCOUNT_"
                                                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                    },
                                                ]}
                                            >
                                                <CompanyAutocomplete
                                                    allowClear={true}
                                                    onChange={this.handleChange}
                                                    style={{ width: "100%" }}
                                                />
                                            </Form.Item>
                                        )}
                                    <Form.Item
                                        name="routeName"
                                        label={
                                            <span>
                                                {this.context.translate("_ROUTE_NAME_")}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[{ required: true, message: `${this.context.translate("_ROUTE_NAME_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name="routeArea"
                                        label={
                                            <span>
                                                {this.context.translate("_AREA_NAME_")}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[{ required: true, message: `${this.context.translate("_AREA_NAME_")} ${this.context.translate("_IS_REQUIRED_")}` }]}
                                    >
                                        <Select
                                            placeholder={this.context.translate(
                                                "_SELECT_AREA_"
                                            )}
                                            style={{ width: "100%" }}
                                            mode="multiple"
                                            optionFilterProp="children"
                                            showSearch
                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}

                                        >
                                            {this.state.arealist.map((val) => {
                                                return (
                                                    <Option key={val.areaId} value={val.areaId}>
                                                        {val.areaName}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <div className="formFooter">
                                <Button
                                    className="formsCancelButton"
                                    onClick={() => {
                                        this.closeModal();
                                    }}
                                >
                                    {this.context.translate(
                                        "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                    )}
                                </Button>
                                <Button
                                    htmlType="submit"
                                    className="formsSaveButton"
                                    loading={this.state.loading}
                                >
                                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                </Button>
                            </div>


                        </Form>
                    </Spin>
                </div>
            </div>
        );
    }
}
StudentRouteAdd.contextType = StoreContext;
export default observer(withRouter(StudentRouteAdd));
